import { combineReducers, configureStore } from "@reduxjs/toolkit";

// reducers
import authReducer from "./reducers/auth.reducer";
import lpReducer from "./reducers/lp.reducer";
import qReducer from "./reducers/questionnaires.reducer";
import leadsReducer from "./reducers/leads.reducer";
import calendarsReducer from "./reducers/calendars.reducer";
import usersReducer from "./reducers/users.reducer";
import teamsReducer from "./reducers/teams.reducer";
import rolesReducer from "./reducers/roles.reducer";
import couponsReducer from "./reducers/coupons.reducer";
import proofNotificationsReducer from "./reducers/proof.notifications.reducer";
import leadStatusListReducer from "./reducers/leads.status.reducer";
import dealsReducer from "./deals/deals.slice";
import pipelinesReducer from "./pipelines/pipelines.slice";
import productsReducer from "./products/products.reducer";
import meetingsReducer from "./meetings/meetings.slice";
import schedulersReducer from "./reducers/schedulers.reducer";
import callCentersReducer from "./call-centers/call-centers.slice";
import trainingReducer from "./training/training.slice";


const rootReducer = combineReducers({
  auth: authReducer,
  lp: lpReducer,
  questionnaires: qReducer,
  leads: leadsReducer,
  leadStatusList: leadStatusListReducer,
  calendars: calendarsReducer,
  users: usersReducer,
  teams: teamsReducer,
  roles: rolesReducer,
  products: productsReducer,
  coupons: couponsReducer,
  proofNotifications: proofNotificationsReducer,
  deals: dealsReducer,
  pipelines: pipelinesReducer,
  meetings: meetingsReducer,
  schedulers: schedulersReducer,
  callCenters: callCentersReducer,
  training: trainingReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
